import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Menubar from "../../../../../components/MenuBar/Menubar";
import styles from "./style.module.css";
import DashboardNavbar from "../../../../../components/DashBoardNavbar";

function ApplicationDetails() {
  const { id } = useParams(); // Get the ID parameter from the URL
  const [application, setApplication] = useState(null); // State to store application data
  const [activeButton, setActiveButton] = useState("applicant"); // State to track active button

  useEffect(() => {
    const fetchApplicationDetails = async () => {
      try {
        const authToken = localStorage.getItem("authtoken");
        const requestOptions = {
          method: "GET",
          headers: {
            "auth-token": authToken,
            Authorization: "Bearer yourToken",
            "Content-Type": "application/json",
          },
        };
        const response = await fetch(
          `https://job-application-mindtech.onrender.com/api/job-applications/${id}`,
          requestOptions
        ); // Replace with your backend API URL
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setApplication(data);
        console.log(data); // Set the fetched application data to state
      } catch (error) {
        console.error("Error fetching application details:", error);
      }
    };

    fetchApplicationDetails();
  }, [id]); // Trigger the effect whenever the ID parameter changes

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
  };

  if (!application) {
    return <div>Loading...</div>;
  }
  const handleViewPdf = (pdfData) => {
    const blob = new Blob([new Uint8Array(pdfData)], {
      type: "application/pdf",
    });
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  const handleDownloadCoverLetter = (data, fileName) => {
    const blob = new Blob([new Uint8Array(data)], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <div>
      <div className={styles.record}>
        <Menubar />
        <div className={styles.applicationContainer}>
          <DashboardNavbar />

          <h3 className={styles.tag1}>Dashboard / Details</h3>
          <h1 className={styles.tag2}>Account Details</h1>
          <div className={styles.insideApplicationContainer}>
            {/* Display application details using application object */}
            <div className={styles.btns}>
              <div
                className={`${styles.btn} ${
                  activeButton === "applicant" && styles.active
                }`}
                onClick={() => handleButtonClick("applicant")}
              >
                Applicant Details
              </div>
              <div
                className={`${styles.btn} ${
                  activeButton === "references" && styles.active
                }`}
                onClick={() => handleButtonClick("references")}
              >
                References
              </div>
              <div
                className={`${styles.btn} ${
                  activeButton === "documents" && styles.active
                }`}
                onClick={() => handleButtonClick("documents")}
              >
                Documents
              </div>
            </div>
            {/* Conditional rendering based on active button */}
            {activeButton === "applicant" && (
              <div className={styles.detailSection}>
                <div className={styles.detail1}>
                  <p>Applicant Name</p>
                  <p className={styles.val2}>{application.name}</p>
                  <p className={styles.val1}>Email Address</p>
                  <p className={styles.val2}>{application.email}</p>
                  <p className={styles.val1}>Date of Birth</p>
                  <p className={styles.val2}>{application.dob}</p>
                </div>
                <div className={styles.detail2}>
                  <p>Phone no</p>
                  <p className={styles.val2}>{application.phone}</p>
                  <p className={styles.val1}>Address </p>
                  <p className={styles.val2}>
                    {application.address} Lorem ipsum dolor sit, amet
                    consectetur adipisicing elit. Est, quidem. Assumenda,
                    architecto.
                  </p>
                  <p className={styles.val1}>Introduction</p>
                  <p className={styles.val2}>
                    {application.introduction} Lorem ipsum dolor sit amet
                    consectetur adipisicing elit. Explicabo tempore est eveniet.
                  </p>
                </div>
              </div>
            )}
            {activeButton === "references" && (
              <div className={styles.detailSection}>
                <div className={styles.detail1}>
                  <p>Reference Name</p>
                  <p className={styles.val2}>{application.name}</p>
                  <p className={styles.val1}>Email Address</p>
                  <p className={styles.val2}>{application.email}</p>
                  <p className={styles.val1}>Title</p>
                  <p className={styles.val2}>
                    {application.referencePersonDesignation} Lorem ipsum dolor
                    sit amet consectetur adipisicing elit. Nobis, corrupti
                    dolorem!
                  </p>
                </div>
                <div className={styles.detail2}>
                  <p>Relationship</p>
                  <p className={styles.val2}>
                    {application.referencePersonRelationship} Lorem, ipsum dolor
                    sit amet consectetur adipisicing elit. Nesciunt, ducimus
                    impedit.
                  </p>
                  <p className={styles.val1}>Linkedin Profile </p>
                  <p className={styles.val2}>
                    {application.referencePersonLinkedin} Lorem ipsum dolor sit,
                    amet consectetur adipisicing elit. Est, quidem. Assumenda,
                    architecto.
                  </p>
                </div>
              </div>
            )}
            {activeButton === "documents" && (
              <div className={styles.detailSection}>
                <div className={styles.documentsSection}>
                  <div className={styles.offerLetter}>
                    <div
                      className={styles.downloadCoverLetter}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleDownloadCoverLetter(
                          application.coverLetter.data,
                          "coverLetter.pdf"
                        )
                      }
                    >
                      Download Offer Letter
                    </div>
                    <div
                      className={styles.downloadCoverLetter}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleViewPdf(application.coverLetter.data)
                      }
                    >
                      View OfferLetter
                    </div>
                  </div>
                  <div className={styles.resume}>
                    <div
                      className={styles.downloadResume}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleDownloadCoverLetter(
                          application.uploadCv.data,
                          "uploadCv.pdf"
                        )
                      }
                    >
                      {/* <PictureAsPdfIcon style={{cursor:'pointer'}} onClick={() => handleDownloadCoverLetter(application.uploadCv.data, 'uploadCv.pdf')} /> */}
                      Download Resume/CV
                    </div>
                    <div
                      className={styles.downloadResume}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleViewPdf(application.uploadCv.data)}
                    >
                      View Resume/CV
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApplicationDetails;
